import { ICreditCardBrand } from '../models/payments';

type CardTypeMetadata = {
  TYPE: string;
  BRAND: ICreditCardBrand;
  PATTERN: RegExp;
  CARD_LENGTH: number[];
  CVV_LENGTH: number[];
  CVV_PATTERN: RegExp;
  SHOW_EXPIRATION: boolean;
};

export const cardBrandFinder = {
  HDMC: {
    TYPE: 'hdmc',
    BRAND: 'HDMC',
    PATTERN: /^530907/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  PROX: {
    TYPE: 'prox',
    BRAND: 'PROX',
    PATTERN: /^(6035322[56]|60353230|60353231[0-4])/,
    CARD_LENGTH: [21],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  CA_PROX: {
    TYPE: 'prox',
    BRAND: 'PROX',
    PATTERN: /^(6035294[5-6]|6035298[01])/,
    CARD_LENGTH: [21],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  HDCOM: {
    TYPE: 'hdcom',
    BRAND: 'HDCOM',
    PATTERN: /^(6035322[01]|60353222[0-9])/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  CA_HDCOM: {
    TYPE: 'hdcom',
    BRAND: 'HDCOM',
    PATTERN: /^(60352943[1-9])/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  CA_HDCON: {
    TYPE: 'hdcon',
    BRAND: 'HDCON',
    PATTERN: /^(60352944)/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  HDCON: {
    TYPE: 'hdcon',
    BRAND: 'HDCON',
    PATTERN: /^(557988|557989|6035320|6035321[0-6])/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: false,
  },

  VISA: {
    TYPE: 'visa',
    BRAND: 'VISA',
    PATTERN: /^4[0-9]/,
    CARD_LENGTH: [13, 16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },

  MA: {
    TYPE: 'mastercard',
    BRAND: 'MA',
    PATTERN: /^5[1-5]|^(?:222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[0-1]\d|2720)/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },

  AMEX: {
    TYPE: 'amex',
    BRAND: 'AMEX',
    PATTERN: /^3[47]/,
    CARD_LENGTH: [15],
    CVV_LENGTH: [4],
    CVV_PATTERN: /^[0-9]{4}$/,
    SHOW_EXPIRATION: true,
  },

  DISC: {
    TYPE: 'discover',
    BRAND: 'DISC',
    PATTERN: /^(6011|65|64[4-9]|622)/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },

  DCI: {
    TYPE: 'discover',
    BRAND: 'DISC',
    PATTERN:
      /^(?:30[0-5][0-9]{3}|3095[0-9]{2}|36[0-9]{4}|3[8-9][0-9]{4})([0-9]{10}|[0-9]{8})$/,
    CARD_LENGTH: [14, 16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },

  PROPURCHASE: {
    TYPE: 'propurchase',
    BRAND: 'PROP',
    PATTERN: /^98/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },

  JCB: {
    TYPE: 'discover',
    BRAND: 'DISC',
    PATTERN:
      /^(?:35[2-8][0-9]{3}|60110[0-3]|60110[5-9]|6011[2-4][0-9]|601174|60117[7-9]|6011[8-9][0-9]|622[1-9][0-9]{2}|62[4-6][0-9]{3}|628[2-8][0-9]{2}|6[4-5][0-9]{4})[0-9]{10}$/,
    CARD_LENGTH: [16],
    CVV_LENGTH: [3],
    CVV_PATTERN: /^[0-9]{3}$/,
    SHOW_EXPIRATION: true,
  },
} satisfies Record<string, CardTypeMetadata>;

export const shouldShowCardExpirationWithBrand = (
  brand: string | undefined,
) => {
  const type = findCardTypeWithBrand(brand);
  return type ? type.SHOW_EXPIRATION : true;
};

export const findCardTypeWithBrand = (brand: string | undefined) => {
  const type = Object.values(cardBrandFinder).find((cardTypeMetadata) => {
    return brand === cardTypeMetadata.BRAND;
  });
  return type;
};
